/* globals dataLayer */

const sendEvents = process.env.REACT_APP_ENABLE_ANALYTICS === 'true';

export function customEvent(event, params = {}) {
    const {category = '', action = '', label = '', ...rest} = params;
    const properties = Object.keys(rest).length === 0 ? '' : rest;
    const addToDatalayer = {event, category, action, label, properties};
    if (sendEvents && dataLayer) {
        dataLayer.push(addToDatalayer);
    } else {
        console.log('Analytics event: ', JSON.stringify(addToDatalayer));
    }
}

export function addToDataLayer(msg) {
    if (sendEvents && dataLayer) {
        dataLayer.push(msg);
    } else {
        console.log('Analytics datalayer: ', msg);
    }
}

export function lessonParamsForAnalytics(lesson) {
    return {
        LessonName: lesson?.name,
        Level: lesson?.level,
        Instruments: lesson?.instruments?.map(instrument => instrument.name),
        Genre: lesson?.category,
        Owner: lesson?.owner?.name,
        Collection: lesson?.labels
    };
}
